(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hexpod-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hexpod-addons')) {
  customElements.define('hexpod-addons', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.hp-addons-track');
      this.previous = this.querySelector('[data-hp-prev]');
      this.next = this.querySelector('[data-hp-next]');
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.move = direction => {
        const step = this.track.querySelector('li').getBoundingClientRect().width + 12;
        const visible = Math.max(1, Math.floor((this.track.clientWidth + 12) / step));
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({left: direction * rtl * step * visible, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.update = () => {
        const position = Math.abs(this.track.scrollLeft);
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = position < 2;
        this.next.disabled = position >= maximum - 2;
        this.querySelector('.hp-addons-controls').hidden = maximum <= 2;
      };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', this.update, {...options, passive: true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight') !== rtl ? 1 : -1);
        }
      }, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
